import { action } from 'satcheljs';

export const getSecondarySubscribers = action('getSecondarySubscribers');
